<template>
  <Modal @close="$emit('close')" :title="titles[selected]">
    <div slot="body" class="body">
      <ProfileView v-if="showView.profile" @changeView="changeView" />
      <AvatarView v-if="showView.avatar" @changeView="changeView" />
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal";
import ProfileView from "@/components/userProfile/ProfileView";
import AvatarView from "@/components/userProfile/AvatarView";

export default {
  name: "ProfileModal",
  components: {
    Modal,
    ProfileView,
    AvatarView,
  },
  data() {
    return {
      showView: {
        profile: true,
        avatar: false,
      },
      titles: {
        profile: "Perfil",
        avatar: "Avatar",
      },
      selected: "profile",
    };
  },
  methods: {
    changeView(selected) {
      for (let view in this.showView) {
        this.showView[view] = false;
      }
      this.showView[selected] = true;
      this.selected = selected;
    },
  },
};
</script>

<style lang="scss" scoped></style>
